import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { useCallback, useState } from 'react'
import { updateQuantities } from 'client/stock-transfers/stock-transfers.client'
import {
  containerLocationAtom,
  productQuantitiesAtom,
  selectedContainersAtom,
  selectedProductAtom
} from 'pages/assembly/Assemby.state'
import { useGoToProducts } from 'pages/assembly/products/Products.navigator'
import type { RegisterQuantitiesData } from 'types/assembly/model'
import { MEASURE_LABELS_PLURAL } from 'utils/constants'
import { toastSuccess } from 'utils/toast'
import { useRequiredParams } from './params.hook'

export const useRegisterProduct = () => {
  const [loading, setLoading] = useState(false)
  const [product, setProduct] = useAtom(selectedProductAtom)
  const [productQuantities, setProductQuantities] = useAtom(
    productQuantitiesAtom
  )
  const setContainerLocation = useSetAtom(containerLocationAtom)
  const { transferId, docNum } = useRequiredParams('transferId', 'docNum')
  const productsPage = useGoToProducts()
  const selectedContainers = useAtomValue(selectedContainersAtom)

  const cleanCurrentProductState = useCallback(() => {
    setProduct(undefined)
    setProductQuantities([])
  }, [setProduct, setProductQuantities])

  const register = async (container: string, location: string) => {
    if (!product) {
      return
    }

    setLoading(true)
    const data: RegisterQuantitiesData = {
      ean: product.barcode,
      quantity: productQuantities,
      location,
      destinationContainer: container
    }
    const total = productQuantities.reduce((acc, curr) => acc + curr, 0)

    try {
      await updateQuantities(transferId, data)
      toastSuccess(
        `Registraste ${total} ${MEASURE_LABELS_PLURAL[product.measureUnit]} de ${product.name} en la tarima ${container}.`
      )
      setContainerLocation({ container, location })
      cleanCurrentProductState()
      productsPage.go(transferId, docNum, selectedContainers)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  return { register, loading }
}
